// export default function Popup (props){
//     return (
//     props.show ? <div className='popup' >
//         {
//             props.children
//         }
//     </div> : null
//     );
// }
import { useState, useEffect } from "react";

export default function Popup({ show, children }) {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(show);

  useEffect(() => {
    if (show) {
      setShouldRender(true);
      // Small delay to ensure the element is in DOM before adding active class for transition
      const timer = setTimeout(() => setIsVisible(true), 20);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
      // Wait for transition duration (matching CSS) before unmounting
      const timer = setTimeout(() => setShouldRender(false), 450);
      return () => clearTimeout(timer);
    }
  }, [show]);

  if (!shouldRender) return null;

  return (
    <div className={`popup-wrapper ${isVisible ? "active" : ""}`}>
      {children}
    </div>
  );
}
